import BaseModel from '../core/BaseModel'

export default class NotificationsModel extends BaseModel {

    constructor() {
        super({
            tableName: 'notification', label: "Quản Lý Thông Báo", display_key: 'id'
        }, {
            stt: { 
                name: "stt", 
                label: "STT", 
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                }
            },
            id: { 
                name: 'id', 
                type: "Bigint", 
                label: 'ID', 
                primaryKey: true,  
                display: false
            },
            title: { 
                name: 'title', 
                type: "String", 
                label: 'Tiêu đề',  
                width: 20,
                class: "center",
            },
            content: { 
                name: 'content', 
                type: "String", 
                class: "center",
                label: 'Nội dung',
                width: 30,
            },
            created_at: { 
                name: 'created_at', 
                type: "Date",
                width: 10,
                class: "center",
                label: 'Ngày tạo',  
                filter: { type: 'DateRange', match: 'contains'}
            },
            list_users: { 
                name: 'list_users', 
                label: 'Mã nhân viên',
                type: "String", 
                display: false
            },
            receiver: { 
                name: 'receiver', 
                label: 'Tất cả',
                type: "Int", 
                display: false
            },
            user_code: {
                name: 'user_code', 
                label: 'Mã nhân viên',
                width: 10,
                class: "center",
                computed: (data) => {
                    if (data.receiver == 1) {
                        data.user_code = "Tất cả"
                    } else {
                        data.user_code = data.list_users
                    }
                }  
            }
        })
    }

}